
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import NewFeedbackModal from "components/Donate/NewFeedbackModal";
import CustomBreadCrumbs from "components/ReuseableCompos/CustomBreadCrumbs";
import CustomContentLoader from "components/ReuseableCompos/CustomContentLoader";
import CustomJumbotron from "components/ReuseableCompos/CustomJumbotron";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import SEO from "components/Seo";
import { NEXT_URL_PROXY } from "config";
import { useAuthContext } from "context/AuthContext";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { postData } from "utils/postData";
import useHeaderTitleSetter from "../customHooks/useHeaderTitleSetter";
import useModal from "../customHooks/useModal";
import newEvent from "../public/lottie/feedback.json";
const Create = () => {
    const { t } = useTranslation("common");
    const { donor } = useAuthContext();
    useHeaderTitleSetter({
        title: t("give_feedback"),
        section: "profile"
    });
    const { showModal: showCreateModal, handleCloseModal: handleCloseCreateModal, handleShowModal: handleShowCreateModal, } = useModal();
    const onCreateButtonClick = () => {
        if (donor) {
            handleShowCreateModal();
        }
    };
    const ref = useRef(null);
    const { locale } = useRouter();
    const [isLoading, setIsLoading] = useState(false);
    const onEventSubmit = async (data) => {
        setIsLoading(true);
        const res = await postData(`${NEXT_URL_PROXY}/feedback`, {
            ...data,
            feedback_subject_id: data.subject
        });
        if (res.status === 200) {
            handleCloseCreateModal();
            toast.success(t("feedback_sent"));
        }
        else {
            toast.error(t("something_went_wrong"));
        }
        setIsLoading(false);
    };
    const Lottie = dynamic(() => import("lottie-react"), {
        loading: () => (<CustomContentLoader viewBox={`0 0 1200 225`} className="pb-3">
        <rect x="calc(50% - 117px)" y="0" rx="8" ry="8" width="225" height="225"></rect>
      </CustomContentLoader>)
    });
    const isMobile = useMobile("lg");
    const desc = t("feedback_intro")
        .split("<p>")[1]
        .split("</p>")[0]
        .replace("&nbsp;", " ");
    return (<>
      <SEO title={t("give_feedback")} description={t("feedback_desc")}/>
      <CustomJumbotron p="py-4" breadCrumbM="my-0" m="mt-0" className="mt-0 ps-2 ps-sm-0 border-bottom" title={t(`give_feedback`)} desc={t(`feedback_desc`)} customBreadCrumbs={<CustomBreadCrumbs transformedLabel={() => {
                return t("give_feedback");
            }}/>}/>
      <div className="container">
        <div className="my-5">
          <div className="">
            <Lottie className="m-auto pb-3" style={{ width: 300 }} animationData={newEvent} loop={true}/>

            {[0].map((_, i) => {
            return (<p key={i} className="text-center fs-18 fw-medium my-5" style={{
                    lineHeight: 2
                }}>
                  {desc}
                </p>);
        })}

            <div className="d-flex justify-content-center">
              <MolhamButton id="event-open-create-btn" startIcon="fe-plus" label={t(`single_targetable-send_feedback`)} className={isMobile && `w-100`} href={donor ? null : "#login"} onClick={onCreateButtonClick}/>
            </div>
            <NewFeedbackModal closeModalOffCanvas={handleCloseCreateModal} showModalOffcanvas={showCreateModal} onSubmit={onEventSubmit} isLoading={isLoading}/>
          </div>
        </div>
      </div>
    </>);
};
export default Create;

    async function __Next_Translate__getStaticProps__1a13f66bdbe__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/feedback',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bdbe__ as getStaticProps }
  